module.exports = __webpack_public_path__ + "img/46.3d0f1dcf.png";